import { protectedAxios } from "@shared/src/utils/axios";
import { handleServiceError } from "@shared/src/utils/error-handler";
import { ClaimFaucetResponse, GetFaucetsResponse } from "@shared/src/types/faucet.types";

export const faucetService = {
  getFaucets: async () => {
    return handleServiceError(async () => {
      const { data } = await protectedAxios.get<GetFaucetsResponse>("/auth/faucet");
      //   if (!data) {
      //     throw new Error("Failed to fetch faucets");
      //   }
      return data;
    });
  },

  claimFaucet: async () => {
    return handleServiceError(async () => {
      const { data } = await protectedAxios.post<ClaimFaucetResponse>("/auth/faucet");
      //   if (!data) {
      //     throw new Error("Failed to claim faucet");
      //   }
      return data;
    });
  },
};
